"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehiclesRequestFactory = exports.SuppliersRequestFactory = exports.CourseReviewRequestFactory = exports.ReviewRequestFactory = exports.ProductsRequestFactory = exports.ProductTypeRequestFactory = exports.CourseRequestFactory = exports.AreaRequestFactory = exports.RegionRequestFactory = exports.CountryRequestFactory = exports.NewsRequestFactory = exports.HotelRequestFactory = exports.AttractionRequestFactory = exports.HotelRoomRequestFactory = exports.CurrencyRequestFactory = exports.AirportRequestFactory = exports.GenericRequestFactory = exports.StorageRequestFactory = exports.OrderRequestFactory = exports.UserRequestFactory = exports.AccountsRequestFactory = exports.EmailTemplateRequestFactory = exports.ExchangeRateRequestFactory = exports.CourseClosureRequestFactory = exports.CourseWarningRequestFactory = exports.TransactionRequestFactory = exports.PublicHolidayRequestFactory = exports.PaymentMethodRequestFactory = exports.AgentRequestFactory = exports.PackageEnquiryRequestFactory = exports.RegionFAQRequestFactory = exports.CountryFAQRequestFactory = exports.SitesRequestFactory = exports.BlogRequestFactory = exports.EmailLogRequestFactory = exports.RateEnquiryRequestFactory = exports.PaymentRequestRequestFactory = exports.NotifyMeRequestFactory = exports.ExcursionRequestFactory = void 0;
const CountryRequestFactory = require("./country");
exports.CountryRequestFactory = CountryRequestFactory;
const RegionRequestFactory = require("./region");
exports.RegionRequestFactory = RegionRequestFactory;
const AreaRequestFactory = require("./area");
exports.AreaRequestFactory = AreaRequestFactory;
const CourseRequestFactory = require("./course");
exports.CourseRequestFactory = CourseRequestFactory;
const ProductTypeRequestFactory = require("./producttype");
exports.ProductTypeRequestFactory = ProductTypeRequestFactory;
const ProductsRequestFactory = require("./products");
exports.ProductsRequestFactory = ProductsRequestFactory;
const ReviewRequestFactory = require("./reviews");
exports.ReviewRequestFactory = ReviewRequestFactory;
const CourseReviewRequestFactory = require("./course_reviews");
exports.CourseReviewRequestFactory = CourseReviewRequestFactory;
const SuppliersRequestFactory = require("./suppliers");
exports.SuppliersRequestFactory = SuppliersRequestFactory;
const NewsRequestFactory = require("./news");
exports.NewsRequestFactory = NewsRequestFactory;
const VehiclesRequestFactory = require("./vehicles");
exports.VehiclesRequestFactory = VehiclesRequestFactory;
const HotelRequestFactory = require("./hotel");
exports.HotelRequestFactory = HotelRequestFactory;
const AttractionRequestFactory = require("./attraction");
exports.AttractionRequestFactory = AttractionRequestFactory;
const AirportRequestFactory = require("./airport");
exports.AirportRequestFactory = AirportRequestFactory;
const HotelRoomRequestFactory = require("./hotelrooms");
exports.HotelRoomRequestFactory = HotelRoomRequestFactory;
const CurrencyRequestFactory = require("./currency");
exports.CurrencyRequestFactory = CurrencyRequestFactory;
const GenericRequestFactory = require("./generic");
exports.GenericRequestFactory = GenericRequestFactory;
const UserRequestFactory = require("./user");
exports.UserRequestFactory = UserRequestFactory;
const StorageRequestFactory = require("./storage");
exports.StorageRequestFactory = StorageRequestFactory;
const OrderRequestFactory = require("./orders");
exports.OrderRequestFactory = OrderRequestFactory;
const AccountsRequestFactory = require("./accounts");
exports.AccountsRequestFactory = AccountsRequestFactory;
const EmailTemplateRequestFactory = require("./email_templates");
exports.EmailTemplateRequestFactory = EmailTemplateRequestFactory;
const ExchangeRateRequestFactory = require("./exchange_rates");
exports.ExchangeRateRequestFactory = ExchangeRateRequestFactory;
const CourseClosureRequestFactory = require("./course_closures");
exports.CourseClosureRequestFactory = CourseClosureRequestFactory;
const CourseWarningRequestFactory = require("./course_warnings");
exports.CourseWarningRequestFactory = CourseWarningRequestFactory;
const PublicHolidayRequestFactory = require("./public_holiday");
exports.PublicHolidayRequestFactory = PublicHolidayRequestFactory;
const TransactionRequestFactory = require("./transactions");
exports.TransactionRequestFactory = TransactionRequestFactory;
const PaymentMethodRequestFactory = require("./payment_methods");
exports.PaymentMethodRequestFactory = PaymentMethodRequestFactory;
const AgentRequestFactory = require("./agents");
exports.AgentRequestFactory = AgentRequestFactory;
const RegionFAQRequestFactory = require("./region_faq");
exports.RegionFAQRequestFactory = RegionFAQRequestFactory;
const CountryFAQRequestFactory = require("./country_faq");
exports.CountryFAQRequestFactory = CountryFAQRequestFactory;
const PackageEnquiryRequestFactory = require("./package_enquiries");
exports.PackageEnquiryRequestFactory = PackageEnquiryRequestFactory;
const SitesRequestFactory = require("./sites");
exports.SitesRequestFactory = SitesRequestFactory;
const EmailLogRequestFactory = require("./email_log");
exports.EmailLogRequestFactory = EmailLogRequestFactory;
const BlogRequestFactory = require("./blog");
exports.BlogRequestFactory = BlogRequestFactory;
const RateEnquiryRequestFactory = require("./rate_enquiries");
exports.RateEnquiryRequestFactory = RateEnquiryRequestFactory;
const PaymentRequestRequestFactory = require("./payment_requests");
exports.PaymentRequestRequestFactory = PaymentRequestRequestFactory;
const NotifyMeRequestFactory = require("./notify_me");
exports.NotifyMeRequestFactory = NotifyMeRequestFactory;
const ExcursionRequestFactory = require("./excursion");
exports.ExcursionRequestFactory = ExcursionRequestFactory;
